import converter from 'number-to-words';

export const numberConv = (w) => {
  return w
    .split(' ')
    .map((e) => {
      try {
        let wordNumber = converter.toWords(e.replace(/,/gi, ''));
        wordNumber = wordNumber.replace(/,/gi, '');
        const hundred = parseInt(e, 10) % 100;
        const thousand = parseInt(e, 10) % 1000;
        if (hundred) {
          wordNumber = wordNumber.replace('hundred', 'hundred and');
          if (thousand) {
            wordNumber = wordNumber.replace('thousand', 'thousand and');
          }
        }
        return wordNumber;
      } catch {
        return e;
      }
    })
    .join(' ');
};
